import { render, staticRenderFns } from "./orderReciept.vue?vue&type=template&id=39cb0257&"
import script from "./orderReciept.vue?vue&type=script&lang=js&"
export * from "./orderReciept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports